import React from "react";
import { useFormikContext } from "formik";
import TextareaController from "components/TextareaController";
import { SCHEMA_TYPES } from "components/FormerEditor/common/constants";
import startCase from "lodash/startCase";
import get from "lodash/get";
import FieldGroup from "components/FormerEditor/FieldGroup";
import { getSchemaValuesForEditor, isDefaultCategory } from "utils/schema";

const FormFactory = ({ schema, name }) => {
  const { values } = useFormikContext();
  const hasSchemaProps = schema && schema.properties;
  if (!hasSchemaProps) {
    console.error(`Schema missing for ${name}`);
  }

  return (
    <div className="ph3 bg-white bh--inset dib w-100">
      {hasSchemaProps &&
        Object.keys(schema.properties).reduce((memo, propertyKey, keyIx) => {
          const {
            rootPath,
            fieldPath,
            dependencies,
            template,
            propSchema,
            properties
          } = getSchemaValuesForEditor({
            name,
            propertyKey,
            schema
          });

          if (isDefaultCategory(propSchema)) {
            if (propSchema.type === SCHEMA_TYPES.ARRAY) {
              memo.push(
                <FieldGroup
                  key={keyIx}
                  label={propSchema.title}
                  name={fieldPath}
                  collection={get(values, fieldPath)}
                  schema={properties}
                  template={template}
                  dependencies={dependencies}
                />
              );
            } else {
              memo.push(
                <div key={keyIx} className="pt3">
                  <TextareaController
                    name={propertyKey}
                    label={propSchema.title || startCase(propertyKey)}
                    rootPath={rootPath}
                    fieldKey={propertyKey}
                    minRows={1}
                  />
                </div>
              );
            }
          }

          return memo;
        }, [])}
    </div>
  );
};

export default FormFactory;
